export const paths = {
    authorize: '/users/authorize',
};